import React, { useMemo } from 'react'
import { convertMetersToMiles } from '../utils'

const SwimProgressBar = props => {
  const { amount, target, fitnessGoal } = props
  const amountMiles = convertMetersToMiles(amount).toFixed(1)
  const targetMiles = convertMetersToMiles(target).toFixed(0)
  return (
    <div className='fitnessBar'>
      {fitnessGoal === 44 && <SwimBar {...props} barId={2} />}
      <SwimBar {...props} barId={fitnessGoal === 44 ? 1 : undefined} />
      <div className='metrics'>
        <div className='fitness'>
          miles:
          <span className='amount'>{amountMiles}</span>
          </div>
          <div className='fitness'>
          Target:
          <span className='amount'>{targetMiles}</span>
        </div>
      </div>
    </div>
  )
}

const SwimBar = ({
  classNames,
  percentage,
  fitnessGoal,
  barId,
  page,
}) => {
  let transform = 'rotate(0deg)'
  let includeMarker = true
  if (fitnessGoal === 44) {
    // we are using two progress bars for 44;
    // so need to update the percentages to take that into account
    fitnessGoal = 22

    if (barId === 1) {
      if (percentage <= 50) {
        includeMarker = false
      }

      percentage = percentage - 50
      transform = 'rotate(168deg)'
    } else {
      if (percentage > 50) {
        includeMarker = false
        percentage = 100
        transform = 'rotate(7deg)'
      }
    }
  }

  const startCircleBackgroundColor = percentage > 0 ? '#db3b00' : 'white'
  const endCircleBackgroundColor = () => {
    if (
      (barId === 1 && percentage >= 50) ||
      (barId !== 1 && percentage >= 100)
    ) {
      return '#db3b00'
    }

    return 'white'
  }

  const stepsArray = useMemo(() => {
    const arr = []
    const localPercentage = barId !== undefined ? percentage * 2 : percentage
    for (let x = 1; x <= fitnessGoal; x++) {
      const currentStep = x
      const completed = Math.floor((fitnessGoal / 100) * localPercentage)
      const backgroundColor = currentStep <= completed ? '#db3b00' : 'white'

      if (
        (includeMarker && currentStep === completed) ||
        (currentStep === 1 && completed === 0)
      ) {
        arr.push(
          <div key={x} className='step' style={{ backgroundColor }}>
            <Icon
              fitnessGoal={fitnessGoal}
              barId={barId}
              percentage={localPercentage}
              page={page}
              classNames={classNames}
            />
          </div>
        )
      } else {
        arr.push(
          <div
            key={x}
            className='step'
            style={{ backgroundColor }}
          />
        )
      }
    }
    return arr
  }, [fitnessGoal])

  return (
    <div className='root' style={{ transform }}>
      {barId !== 1 && (
        <div
          className='circle'
          style={{
            marginRight: -12,
            backgroundColor: startCircleBackgroundColor
          }}
        />
      )}
      {stepsArray}
      {barId !== 2 && (
        <div
          className='circle'
          style={{
            marginLeft: -2,
            backgroundColor: endCircleBackgroundColor()
          }}
        />
      )}
    </div>
  )
}

const Icon = ({
  barId,
  fitnessGoal,
  page,
  percentage
}) => {
  const firstBar = fitnessGoal === 11 ? 10 : 5
  const defaultAvatar = "https://s3.us-east-1.amazonaws.com/docs.blackbaud.services/public/images/swimDefault.webp"
  const avatar = handleAvatar(page, defaultAvatar)
  const flip = barId === 1
  const transform = flip ? 'rotate(180deg)' : undefined
  const markerTop = flip ? 35 : -55
  const avatarTop = flip ? 35 : undefined
  const style = { transform }
  const hide = barId === 2 && percentage === 100

  if (hide) {
    return null
  }

  return (
    <div style={{ marginLeft: percentage < firstBar ? -40 : undefined }}>
      <img
        src="https://s3.us-east-1.amazonaws.com/docs.blackbaud.services/public/images/Icon.png"
        alt='Marker'
        style={{ ...style, position: 'absolute', top: markerTop }}
        className='icon'
      />
      <img
        className='avatar'
        src={avatar.url}
        alt='Avatar'
        style={{
          ...style,
          position: 'relative',
          top: avatarTop,
          borderRadius: '100%'
        }}
      />
    </div>
  )
}

const defaultAvatarRegex = new RegExp('Stock|trainer-no-branding_web')
const isDefaultAvatar = image => defaultAvatarRegex.test(image)
const handleAvatar = ({ hasUpdatedImage, image }, defaultAvatar) =>
  hasUpdatedImage === false || !image || isDefaultAvatar(image)
    ? defaultAvatar
    : image

export default SwimProgressBar;